import React from 'react';
import PropTypes from 'prop-types';
import { H6 } from 'components/Typography';
import { CLAIM_TYPES } from 'products/nomad_insurance/views/ClaimsForm/consts';
import { Instructions } from 'products/nomad_insurance/views/ClaimsForm/styled';
import { NeededDocs } from './styled';

const UploadInstructions = ({ claimType }) => {
  if (claimType === CLAIM_TYPES.TRAVEL) {
    return (
      <>
        <H6>Please upload your documents</H6>
        <Instructions>
          Every claim will need to be supported by documents that confirm you’ve met the
          requirements of the benefit you are claiming for.
        </Instructions>
        <NeededDocs>
          This could be:
          <li>Invoice/receipts</li>
          <li>A report from the police or from the airline</li>
          <li>Proof of ownership of the item you’re claiming for</li>
        </NeededDocs>
      </>
    );
  }
  return (
    <>
      <H6>Please upload a copy of your medical receipts</H6>
      <Instructions>
        Every claim will need to be supported by documents that confirm you have met the
        requirements of the benefit you are claiming for.
      </Instructions>
      <NeededDocs>
        You most likely need:{' '}
        <li>
          A medical report (note from doctor with your symptoms, date of onset, diagnosis
          and treatment)
        </li>
        <li>Invoice/receipts (should show the cost broken down)</li>
        <li>Referral note, lab/scan result, prescription (if relevant)</li>
      </NeededDocs>
    </>
  );
};

UploadInstructions.propTypes = {
  claimType: PropTypes.string
};

export default UploadInstructions;
